<template>
  <div>
    <div class="d-flex">
      <div class="side-frame-success"></div>
      <div>
        <span style="font-size: 14px; color: #606266">
          Bill No：{{ formData.freightDeductionNo || 'New' }}
        </span>
        <el-divider
          direction="vertical"
          v-if="formData.shipmentScmDeductionStatus"
        ></el-divider>
        <b-badge
          v-if="formData.shipmentScmDeductionStatus"
          style="font-size: 12px"
          :variant="
            formData.shipmentScmDeductionStatus === 'W'
              ? 'primary'
              : formData.shipmentScmDeductionStatus === 'S'
              ? 'warning'
              : formData.shipmentScmDeductionStatus === 'D' ||
                formData.shipmentScmDeductionStatus === 'R'
              ? 'danger'
              : formData.shipmentScmDeductionStatus === 'Y'
              ? 'success'
              : ''
          "
        >
          {{ formData.v_shipmentScmDeductionStatus }}
        </b-badge>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          Update：{{ formData.modifyByName || '--' }} at
          {{ formData.modifyTime || '--' }}
        </span>
      </div>
    </div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      size="mini"
    >
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_shipmentContractNo') || '外运编号'"
            prop="shipmentContractNo"
          >
            <el-input
              v-model="formData.shipmentContractNo"
              :placeholder="$l('INDEX.tips_select_placeholder') || '请选择...'"
              readonly
            >
              <el-button
                slot="append"
                icon="el-icon-finished"
                @click="chooseBookingVisible = true"
              ></el-button>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$l('form_label_shipmentNo') || '发运单编号'">
            <el-input v-model="formData.shipmentNo" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$l('form_label_customer') || '客户'">
            <el-input v-model="formData.custName" readonly> </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_deductionScmCode') || '扣款供应商'"
            prop="deductionScmCode"
          >
            <dict-select
              v-model="formData.deductionScmCode"
              url="/master/common/dict/allScmCooperated"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              filterable
              clearable
              size="mini"
              style="width:100%"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_deductionMethod') || '扣款方式'"
            prop="deductionMethod"
          >
            <dict-select
              v-model="formData.deductionMethod"
              url="/master/common/dict/biz"
              :body="deductionMethodParams"
              :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
              size="mini"
              filterable
              clearable
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_currencyTotalAmount') || '费用合计'"
          >
            <el-input v-model="v_currencyTotalAmount" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_currencyUnit') || '货币单位'"
            prop="currencyUnit"
          >
            <dict-select
              v-model="formData.currencyUnit"
              url="/master/common/dict/biz"
              :body="currencyUnitParams"
              :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
              size="mini"
              clearable
              filterable
            ></dict-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item
            :label="$l('form_label_remark') || '扣款原因'"
            prop="remark"
          >
            <el-input
              v-model="formData.remark"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              maxlength="200"
              show-word-limit
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <ItemTable
          ref="itemTable"
          :disabled="disabled"
          :tableData="formData.listItem"
          @updateTotAmount="(e) => (formData.currencyTotalAmount = e)"
        />
      </el-row>
      <el-row>
        <DocTable
          ref="docTable"
          :disabled="disabled"
          :tableData="formData.listDoc"
        />
      </el-row>
    </el-form>
    <BookingOptional
      :visible.sync="chooseBookingVisible"
      :title="$l('dialog_title_choose_shipment_booking') || '选择订舱记录'"
      @confirm="chooseBookingConfirm"
    />
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import ItemTable from '../item-table'
import DocTable from '../doc-table'
import BookingOptional from '../booking-optional'
export default {
  components: { ItemTable, DocTable, BookingOptional },
  mixins: [EditLoading],
  props: {
    freightDeductionCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      formData: {
        currencyTotalAmount: 0,
        deductionMethod: 'A',
      },
      chooseBookingVisible: false,
      expensePayerParams: { dictType: 'expensePayer' },
      currencyUnitParams: { dictType: 'bankAccountKind' },
      deductionMethodParams: { dictType: 'deductionMethod' },
    }
  },
  computed: {
    v_currencyTotalAmount() {
      const { currencyTotalAmount } = this.formData
      return !currencyTotalAmount ? '0' : currencyTotalAmount.toLocaleString()
    },
    rules() {
      return {
        shipmentContractNo: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        deductionScmCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        currencyUnit: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        deductionMethod: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        remark: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
      }
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    ...mapActions('admin/page', ['close']),
    getData() {
      if (!this.freightDeductionCode) return
      this.$api
        .shipmentFreightDeductionDetailApi({
          freightDeductionCode: this.freightDeductionCode,
        })
        .then((res) => {
          const data = res.body
          this.formData = data
        })
    },
    chooseBookingConfirm(e) {
      if (!e) return
      const { shipmentCode, shipmentNo, contractNo, custCode, custName } = e
      this.formData = {
        ...this.formData,
        shipmentContractNo: contractNo,
        shipmentCode,
        shipmentNo,
        custCode,
        custName,
      }
    },
    async save() {
      const result = await this.formValidate()
      if (!result) return

      const listItem = this.$refs.itemTable.getTableData()
      const listDoc = this.$refs.docTable.getTableData()

      this.loadingOpen()
      const res = await this.$api
        .shipmentFreightDeductionSaveApi({
          ...this.formData,
          listItem,
          listDoc,
        })
        .catch(() => null)
      this.loadingClose()
      const { status } = res || {}
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })
      if (!this.freightDeductionCode) {
        this.closeCurPage()
      } else {
        this.getData()
      }
    },
    async formValidate() {
      const formResult = await validate.formValidate([this.$refs.form])
      const itemTableResult = await this.$refs.itemTable.validate()
      return formResult && itemTableResult
    },
    async closeCurPage() {
      await this.close({
        tagName: this.$route.fullPath,
        showConfirm: false,
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
.side-frame-warning {
  padding: 1px 5px;
  border-left: 3px solid $color-warning;
  height: 20px;
  margin-top: 3px;
}
</style>
